import {
  ALGOLIA_INDEX_NAME_LEXICON,
  ALGOLIA_INDEX_NAME_NEWS,
} from '../env.config'
import type { IndexType } from './types'

export const getIndexProps = (indexType: IndexType) => {
  try {
    switch (indexType) {
      case 'news':
        return {
          indexName: ALGOLIA_INDEX_NAME_NEWS,
          key: 'newsSearch',
        } as { indexName: string; key: string }

      case 'lexicon':
        return {
          indexName: ALGOLIA_INDEX_NAME_LEXICON,
          key: 'lexiconSearch',
        } as { indexName: string; key: string }

      default:
        throw new Error(
          'The Index Type does not exist, check if the correct index type is being used.'
        )
    }
  } catch (error) {
    return { indexName: undefined, key: undefined }
  }
}
